import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { bopsApi } from '@Network';

interface UseScheduleWeeksParams {
  scheduleId: string;
  from: string;
  to: string;
  enabled: boolean;
}

interface UpdateScheduleWeekAlertCeilingParams {
  weekStart: string;
  alertCeilingPct: number | null;
}

const useScheduleWeeks = ({ scheduleId, from, to, enabled }: UseScheduleWeeksParams) =>
  useQuery({
    queryKey: ['schedule-weeks', scheduleId, from, to],
    queryFn: () => bopsApi.getScheduleWeeks(scheduleId, from, to),
    enabled,
  });

const useUpdateScheduleWeekAlertCeiling = (scheduleId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ weekStart, alertCeilingPct }: UpdateScheduleWeekAlertCeilingParams) =>
      bopsApi.updateScheduleWeekAlertCeiling(scheduleId, weekStart, alertCeilingPct),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['schedule-weeks', scheduleId] }),
  });
};

export { useScheduleWeeks, useUpdateScheduleWeekAlertCeiling };
